import { Modal } from 'ui';

import { UnsubscribeModalContent } from '../../../Communications/components/UnsubscribeModal';
import {
  ModalTitleWithBackButton,
  useCommunicationListsModalProvider,
} from './CommunicationListsProvider';

const UnsubscribeFromCauseModalContent = () => {
  const { meta, close, openBack } = useCommunicationListsModalProvider({
    id: 'Unsubscribe',
  });

  return (
    <UnsubscribeModalContent
      onClose={close}
      causeId={meta?.causeId}
      onUnsubscribe={openBack}
      onCancel={openBack}
    />
  );
};
const UnsubscribeFromCauseModal = () => {
  const { opened, close } = useCommunicationListsModalProvider({ id: 'Unsubscribe' });

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={<ModalTitleWithBackButton>Unsubscribe</ModalTitleWithBackButton>}
    >
      <UnsubscribeFromCauseModalContent />
    </Modal>
  );
};

export { UnsubscribeFromCauseModal };
